import { asset } from "@/lib/assets";

const LOGOS = [
// `w`/`h` are each file's intrinsic size: the browser reserves the right width before
// the image arrives, so the strip does not shift. Raster logos are sized for this 28px
// strip at 3x — export new ones at about 84px tall, as WebP.
  { name: "L ANANTH Global Trade", src: asset("/assets/clients/lananth.svg"), w: 2776, h: 748 },
  { name: "The GlobiTax", src: asset("/assets/clients/globitax.webp"), invert: true, w: 285, h: 84 },
  { name: "Environsy", src: asset("/assets/clients/environsy.webp"), invert: true, w: 210, h: 84 },
  { name: "Basilius International", src: asset("/assets/clients/basilius.svg"), w: 1070, h: 241 },
  { name: "S.D.V. Public School", src: asset("/assets/clients/sdv.webp"), w: 84, h: 84 },
  { name: "Abhishek Srivastav", src: asset("/assets/clients/abhishek.webp"), w: 95, h: 84 },
  { name: "ABS Group India", src: asset("/assets/clients/abs.webp"), invert: true, w: 285, h: 180 },
  { name: "EduAnant", src: asset("/assets/clients/eduanant.svg"), w: 830, h: 500 },
];

const Item = ({ logo }) => (
  <span
    className={`group flex shrink-0 items-center rounded-xl px-2.5 py-1.5 transition-colors duration-500 ${
      logo.invert ? "hover:bg-white/95" : ""
    }`}
    data-testid={`banner-logo-${logo.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
  >
    <img
      src={logo.src}
      alt={logo.name}
      width={logo.w}
      height={logo.h}
      loading="lazy"
      decoding="async"
      className={`h-7 w-auto opacity-50 grayscale transition-[opacity,filter] duration-500 group-hover:opacity-100 group-hover:grayscale-0 ${
        logo.invert ? "invert group-hover:invert-0" : ""
      }`}
    />
  </span>
);

const Strip = () => (
  <>
    {LOGOS.map((l) => (
      <Item key={l.name} logo={l} />
    ))}
  </>
);

const ClientLogoBanner = () => (
  <section
    className="overflow-hidden border-b border-white/10 py-8"
    data-testid="client-logo-banner"
    aria-label="Clients we have worked with, and our own product"
  >
    {LOGOS.length > 5 ? (
      <div className="relative [mask-image:linear-gradient(90deg,transparent,black_10%,black_90%,transparent)]">
        <div className="flex w-max animate-marquee-third items-center gap-16 pr-16">
          <Strip />
          <Strip />
          <Strip />
        </div>
      </div>
    ) : (
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 md:px-12">
        <Strip />
      </div>
    )}
  </section>
);

export default ClientLogoBanner;
